/* SkinVibe pasek zakładek karty produktu (sections/sv-pdp-zakladki.liquid), karta produktu 2.0, 09.10.2026.
   - Filtr: domyślnie „Opis” = cała karta. „Opinie”/„Dane techniczne” = jeden atrybut data-sv-tab na wrapperze sekcji
     paska; ukrywanie robią reguły CSS z sekcji (przedrostki kluczy sekcji), tu nie ma pętli po sekcjach przy kliknięciu.
   - Po przełączeniu przewijamy do miejsca paska (pasek przyklejony pod nagłówkiem). Miejsce paska zależy tylko od sekcji
     NAD nim (baner, main), których content-visibility z main-product.liquid nie pomija, więc przyciski celowo NIE mają
     data-sv-jump: wymuszony układ całej strony przy pierwszym dotknięciu kosztował ok. 300 ms (lab CPU 4x, 09.10).
     sv-cv-off (prawdziwe wysokości sekcji) włączamy tylko przy skoku do elementu pod paskiem (sv:tab z target, hash).
   - Pasek przykleja się pod nagłówkiem: --sv-tabs-top = wysokość .section-header z ResizeObserver (zmienna motywu
     --header-height nie zmienia się, gdy logo maleje po przewinięciu: 66 -> 55 px na telefonie).
   - Chowa się przy przewijaniu w dół, wraca przy każdym ruchu w górę (>= 3 px); 500 ms po przełączeniu się nie chowa.
     Nasłuch scroll pasywny, praca w requestAnimationFrame (1 odczyt pozycji na klatkę).
   - „Zobacz też” (koniec widoku Opinie i Dane): <template> z sekcji wstawiany przed „Może Ci się spodobać” przy pierwszym
     przełączeniu.
   - Gwiazdki pod tytułem (Judge.me) w widoku Dane: najpierw „Opinie”, potem przewija Judge.me (faza przechwytywania).
     Link z # do sekcji z ukrytej grupy: przełączenie na grupę celu (albo „Opis”) przed skokiem przeglądarki.
   - Kontrakt z blokiem „W zestawie”: document.dispatchEvent(new CustomEvent('sv:tab', {detail: {tab: 'dane', target: el}}))
     -> przełączenie i przewinięcie do el; window.svPdpTabs = true, gdy pasek działa.
   - Pomiar: sv_pdp_tab {tab: opis|opinie|dane, product: handle, ui_from: pasek|zobacz_tez|gwiazdki|link|w_zestawie} (NIE „source”: GA4 bierze go za źródło ruchu sesji; sesja wydajności 09.10)
     -> GA4 (kolejka zgody jak assets/sv-howto.js w wersji K4) i Shopify.analytics.publish('skinvibe_pdp_tab') zawsze. */
(function () {
  'use strict';
  if (window.__svTabsLoaded) return;
  window.__svTabsLoaded = true;

  var GA4_ID = '';
  /* zgoda (kopia K4 z assets/sv-howto.js, wzorzec assets/sv-events.js): dataLayer i GA4 tylko przy zgodzie analitycznej
     z Shopify Customer Privacy API. Zdarzenie sprzed decyzji w banerze czeka w kolejce (max ok. 10 min) i idzie po
     „Akceptuj” (1 s po zgodzie, żeby Consentmo zdążył zaktualizować tryb zgody gtag; bez czekania, gdy zgoda była
     sprzed wejścia na stronę); „Odrzuć” albo brak decyzji przez 10 min = kolejka wyczyszczona. */
  var ga4Ready = false, gaQueue = [], gaPoll = null, gaTries = 0, consentYesAt = 0, consentWaited = false;
  function consentState() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return 'na';
    try {
      if (cp.analyticsProcessingAllowed()) return 'yes';
      var c = typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : null;
      return c && c.analytics === 'no' ? 'no' : '';
    } catch (e) { return 'na'; }
  }
  function gaFlush() {
    var st = consentState();
    if (st === '') consentWaited = true;
    if (st === 'no') { gaQueue.length = 0; return true; }
    if (st !== 'yes') return false;
    if (consentWaited) {
      if (!consentYesAt) consentYesAt = Date.now();
      if (Date.now() - consentYesAt < 1000) return false;
    }
    for (var i = 0; i < gaQueue.length; i++) {
      if (gaQueue[i].dl) continue;
      gaQueue[i].dl = true;
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: gaQueue[i].name }, gaQueue[i].data));
      } catch (e) {}
    }
    if (!GA4_ID) { gaQueue.length = 0; return true; }
    if (typeof window.gtag !== 'function') return false;
    if (!ga4Ready) { window.gtag('config', GA4_ID, { send_page_view: false }); ga4Ready = true; }
    while (gaQueue.length) {
      var q = gaQueue.shift();
      try { window.gtag('event', q.name, Object.assign({ send_to: GA4_ID }, q.data)); } catch (e) {}
    }
    return true;
  }
  function gaSend(name, data) {
    gaQueue.push({ name: name, data: data, dl: false });
    if (gaFlush() || gaPoll) return;
    gaTries = 0;
    gaPoll = setInterval(function () {
      gaTries++;
      if (gaFlush() || gaTries > 2400) { clearInterval(gaPoll); gaPoll = null; gaQueue.length = 0; }
    }, 250);
  }
  /* analityka po narysowaniu klatki (wzorzec Shopify „yield to main thread”, perf 30.09 B-17), żeby dotknięcie
     najpierw zmieniało ekran. Karta w tle = od razu. */
  function afterPaint(cb) {
    if (document.hidden || typeof requestAnimationFrame !== 'function') { cb(); return; }
    requestAnimationFrame(function () { setTimeout(cb, 0); });
  }
  function track(name, data) {
    afterPaint(function () { trackNow(name, data); });
  }
  function trackNow(name, data) {
    var payload = data || {};
    try { gaSend(name, payload); } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish('skinvibe_' + name.replace(/^sv_/, ''), payload);
      }
    } catch (e) {}
  }

  var TABS = { opis: true, opinie: true, dane: true };
  var LOCK_MS = 500;
  var MOVE_PX = 3;

  function list(s) {
    var out = [];
    String(s || '').split(',').forEach(function (x) { x = x.trim(); if (x) out.push(x); });
    return out;
  }
  function now() { return window.performance && performance.now ? performance.now() : Date.now(); }

  function start() {
    var nav = document.querySelector('[data-sv-tabs]');
    if (!nav || nav.__svTabs) return;
    nav.__svTabs = true;
    if (nav.hasAttribute('data-design-mode')) return;
    var wrap = nav.closest('.shopify-section');
    if (!wrap || !wrap.parentNode) return;
    if (nav.getAttribute('data-ga4')) GA4_ID = nav.getAttribute('data-ga4');

    var root = document.documentElement;
    var parent = wrap.parentNode;
    var keys = {
      opinie: list(nav.getAttribute('data-opinie')),
      dane: list(nav.getAttribute('data-dane')),
      zawsze: list(nav.getAttribute('data-zawsze'))
    };
    var product = nav.getAttribute('data-product') || '';
    var buttons = Array.prototype.slice.call(nav.querySelectorAll('[data-sv-tab-go]'));
    var hdr = document.querySelector('.section-header');
    var cur = 'opis';
    var next = null;
    var up = false;
    var lockUntil = 0;
    var topPx = 0;
    var ref = window.pageYOffset;
    var ticking = false;

    function has(id, arr) {
      for (var i = 0; i < arr.length; i++) if (id.indexOf('__' + arr[i]) !== -1) return true;
      return false;
    }
    /* grupa elementu: 'gora' (nad paskiem albo poza <main>), 'zawsze', 'opinie', 'dane', 'opis' - te same listy co CSS */
    function groupOf(el) {
      var sec = el && el.closest ? el.closest('.shopify-section') : null;
      if (!sec || sec === wrap || sec.parentNode !== parent) return 'gora';
      if (!(wrap.compareDocumentPosition(sec) & 4)) return 'gora';
      var id = sec.id || '';
      if (has(id, keys.zawsze)) return 'zawsze';
      if (has(id, keys.opinie)) return 'opinie';
      if (has(id, keys.dane)) return 'dane';
      return 'opis';
    }
    function hiddenIn(g, tab) {
      if (g === 'gora' || g === 'zawsze' || tab === 'opis') return false;
      return g !== tab;
    }
    function tabFor(g) { return g === 'opinie' || g === 'dane' ? g : 'opis'; }
    function byHash(h) {
      if (!h || h.length < 2) return null;
      try { return document.getElementById(decodeURIComponent(h.slice(1))); } catch (e) { return null; }
    }

    function setUp(v) {
      if (v === up) return;
      up = v;
      wrap.classList.toggle('sv-tabs-up', v);
    }
    function setTop(h) {
      h = Math.max(0, Math.round(h || 0));
      if (h === topPx) return;
      topPx = h;
      wrap.style.setProperty('--sv-tabs-top', h + 'px');
    }

    /* naturalne miejsce paska (górna krawędź, gdy nie jest przyklejony) = dół poprzedniej widocznej sekcji */
    function naturalTop() {
      var prev = wrap.previousElementSibling;
      while (prev && !prev.getClientRects().length) prev = prev.previousElementSibling;
      return prev ? prev.getBoundingClientRect().bottom : wrap.getBoundingClientRect().top;
    }
    function barY() {
      return Math.max(0, Math.round(naturalTop() + window.pageYOffset - topPx));
    }
    function targetY(el) {
      if (!el.getClientRects().length) return barY();
      var r = el.getBoundingClientRect();
      return Math.max(0, Math.round(r.top + window.pageYOffset - topPx - nav.offsetHeight - 8));
    }

    function ensureNext() {
      if (next) return;
      var tpl = wrap.querySelector('template[data-sv-tabs-next]');
      if (!tpl || !tpl.content || !tpl.content.firstElementChild) return;
      next = tpl.content.firstElementChild.cloneNode(true);
      next.addEventListener('click', onBtn);
      var rel = null;
      for (var s = wrap.nextElementSibling; s; s = s.nextElementSibling) {
        if (s.id && s.id.indexOf('__related-products') !== -1) { rel = s; break; }
      }
      parent.insertBefore(next, rel);
    }

    /* widok Dane: specyfikacja od razu rozwinięta (to samo, co klik w nagłówek sekcji dane-techniczne-*), bez animacji
       max-height, żeby pozycje liczone zaraz potem były ostateczne.
       P5 10.10: karty <details data-sv-dane-otworz> (Specyfikacja, Instrukcja i opis) otwierane od razu atrybutem open, bez
       ruchu z assets/sv-rozwijane.js; karta Bezpieczeństwo i producent nie ma atrybutu, więc zostaje zamknięta. */
    function openSpecs() {
      var list = parent.querySelectorAll('.specs-content[id^="specs-content-"]');
      var done = [];
      for (var i = 0; i < list.length; i++) {
        var c = list[i];
        if (c.classList.contains('expanded') || groupOf(c) !== 'dane') continue;
        c.style.transition = 'none';
        c.classList.add('expanded');
        var a = document.getElementById('specs-arrow-' + c.id.slice(14));
        if (a) a.classList.add('specs-arrow-rotated');
        done.push(c);
      }
      var karty = parent.querySelectorAll('details[data-sv-dane-otworz]');
      for (var k = 0; k < karty.length; k++) {
        if (!karty[k].open && groupOf(karty[k]) === 'dane') karty[k].open = true;
      }
      if (done.length) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            done.forEach(function (c) { c.style.transition = ''; });
          });
        });
      }
    }

    /* Judge.me skraca długie opinie do 3 linii przy starcie widżetu, licząc wysokości. Gdy widżet startował ukryty
       (widok Dane włączony, zanim Judge.me skończył), skrót się nie liczy (lab 09.10: opinie 170 i 299 px zamiast 57 px).
       Po pokazaniu widżetu wołamy wtedy raz jego własne skracanie (po narysowaniu klatki, w try/catch). */
    var jmFix = false;
    function jmWidget() { return document.getElementById('judgeme_product_reviews'); }
    function fixJm() {
      try {
        var j = window.jdgm, w = jmWidget();
        if (!j || !w || typeof j.setupLimitingReviewHeight !== 'function' || typeof j.$ !== 'function') return;
        if (!w.classList.contains(j.DONE_SETUP_WIDGET_CLASS || 'jdgm--done-setup-widget')) return;
        j.setupLimitingReviewHeight(j.$(w));
      } catch (e) {}
    }

    function switchTo(tab, how) {
      if (!TABS[tab]) return;
      how = how || {};
      if (tab === 'dane') {
        var jw = jmWidget();
        if (jw && !jw.classList.contains('jdgm--done-setup-widget')) jmFix = true;
      } else if (jmFix) {
        jmFix = false;
        afterPaint(fixJm);
      }
      /* skok do elementu pod paskiem: content-visibility off (jak klik w [data-sv-jump]), żeby jego pozycja była prawdziwa */
      if (how.target && !root.classList.contains('sv-cv-off') && 'contentVisibility' in root.style) root.classList.add('sv-cv-off');
      cur = tab;
      wrap.setAttribute('data-sv-tab', tab);
      press(tab);
      if (tab !== 'opis') ensureNext();
      if (tab === 'dane') openSpecs();
      setUp(false);
      lockUntil = now() + LOCK_MS;
      if (how.scroll !== false) {
        window.scrollTo(0, how.target ? targetY(how.target) : barY());
      }
      ref = window.pageYOffset;
      if (how.focus) {
        var act = nav.querySelector('[aria-pressed="true"]');
        if (act) { try { act.focus({ preventScroll: true }); } catch (e) { act.focus(); } }
      }
      if (how.source) track('sv_pdp_tab', { tab: tab, product: product, ui_from: how.source });
    }

    /* dotknięcie zakładki (pasek, Zobacz też, Enter/Spacja na przycisku): od razu tylko podkreślenie (aria-pressed), żeby
       klatka z nową zakładką narysowała się przed ciężkim przeliczeniem układu; całe przełączenie po narysowaniu klatki
       (wzorzec „yield to main thread”, jak track/afterPaint). sv:tab, gwiazdki i hash przełączają od razu (muszą zdążyć
       przed Judge.me, skokiem przeglądarki i skryptem nadawcy). */
    function press(tab) {
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].setAttribute('aria-pressed', String(buttons[i].getAttribute('data-sv-tab-go') === tab));
      }
    }
    function onBtn(e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-sv-tab-go]') : null;
      if (!b) return;
      var tab = b.getAttribute('data-sv-tab-go');
      if (!TABS[tab]) return;
      var inNext = !!(next && next.contains(b));
      press(tab);
      afterPaint(function () {
        switchTo(tab, { source: inNext ? 'zobacz_tez' : 'pasek', focus: inNext });
      });
    }
    nav.addEventListener('click', onBtn);

    /* klawiatura: strzałki między zakładkami (Enter/Spacja obsługuje przycisk) */
    nav.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var i = buttons.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      buttons[(i + (e.key === 'ArrowRight' ? 1 : buttons.length - 1)) % buttons.length].focus();
    });
    wrap.addEventListener('focusin', function () { setUp(false); });

    /* gwiazdki i linki z # do ukrytej grupy: przełączenie PRZED obsługą Judge.me i skokiem przeglądarki */
    document.addEventListener('click', function (e) {
      if (cur === 'opis') return;
      var t = e.target;
      if (!t || !t.closest) return;
      var badge = t.closest('.jdgm-prev-badge, .jdgm-preview-badge');
      if (badge) {
        if (cur === 'dane' && groupOf(badge) === 'gora') switchTo('opinie', { scroll: false, source: 'gwiazdki' });
        return;
      }
      var a = t.closest('a[href*="#"]');
      if (!a || !a.hash || a.pathname !== location.pathname) return;
      var el = byHash(a.hash);
      var g = el ? groupOf(el) : null;
      if (g && hiddenIn(g, cur)) switchTo(tabFor(g), { scroll: false, source: 'link' });
    }, true);
    document.addEventListener('keydown', function (e) {
      if (cur !== 'dane' || (e.key !== 'Enter' && e.key !== ' ')) return;
      var t = e.target;
      var badge = t && t.closest ? t.closest('.jdgm-prev-badge, .jdgm-preview-badge') : null;
      if (badge && groupOf(badge) === 'gora') switchTo('opinie', { scroll: false, source: 'gwiazdki' });
    }, true);
    window.addEventListener('hashchange', function () {
      if (cur === 'opis') return;
      var el = byHash(location.hash);
      var g = el ? groupOf(el) : null;
      if (g && hiddenIn(g, cur)) switchTo(tabFor(g), { target: el, source: 'link' });
    });

    /* kontrakt z blokiem „W zestawie” (i innymi): sv:tab {tab, target} */
    document.addEventListener('sv:tab', function (e) {
      var d = (e && e.detail) || {};
      if (!TABS[d.tab]) return;
      switchTo(d.tab, {
        target: d.target && d.target.nodeType === 1 ? d.target : null,
        source: typeof d.source === 'string' && d.source ? d.source : 'w_zestawie'
      });
    });

    /* przyklejenie pod nagłówkiem: wysokość nagłówka (zmienia się, gdy logo maleje po przewinięciu) */
    if (hdr && 'ResizeObserver' in window) {
      new ResizeObserver(function (entries) {
        var en = entries[entries.length - 1];
        var bs = en.borderBoxSize && (en.borderBoxSize[0] || en.borderBoxSize);
        setTop(bs && bs.blockSize ? bs.blockSize : hdr.offsetHeight);
      }).observe(hdr);
    } else if (hdr) {
      setTop(hdr.offsetHeight);
    }

    /* chowanie przy przewijaniu w dół, powrót przy ruchu w górę.
       Poprawka 10.10 (uwaga CEO 09.10: „w miejscu, gdzie pasek jest stałym blokiem, ma się zachowywać jak normalna
       sekcja, w dół i z powrotem”):
       - gdy miejsce paska jest na ekranie, pasek nie jest przyklejony (position: relative), więc przewija się razem
         z treścią jak zwykła sekcja; przesuwa go przeglądarka, nie skrypt, więc nie odstaje przy szybkim ruchu palcem;
       - gdy schowa się w całości pod nagłówkiem, przechodzi bez animacji w tryb przyklejony i schowany; dalej na karcie
         działa jak dotąd: ruch w dół chowa, ruch w górę wysuwa;
       - bliżej niż pół ekranu od swojego miejsca ruch w górę go nie wysuwa: pasek wraca razem z treścią;
       - przyklejony pasek w strefie swojego miejsca zostaje do chwili, gdy wejdzie w swoje miejsce albo to miejsce
         schowa się pod nagłówkiem, więc pod nagłówkiem nigdy nie zostaje pusty pas po pasku. */
    var flow = false;
    function setFlow(v) {
      if (v === flow) return;
      flow = v;
      wrap.style.position = v ? 'relative' : '';
      wrap.style.top = v ? '0px' : '';
    }
    function instant(fn) {
      wrap.style.transition = 'none';
      fn();
      void wrap.offsetHeight;
      requestAnimationFrame(function () { wrap.style.transition = ''; });
    }
    function onFrame() {
      ticking = false;
      var y = window.pageYOffset;
      /* d = o ile miejsce paska weszło pod dolną krawędź nagłówka (do 1 px: pasek stoi w swoim miejscu; pozycje mają ułamki piksela) */
      var d = topPx - naturalTop();
      var h = wrap.offsetHeight + 2;
      /* po kliknięciu zakładki pasek stoi w swoim miejscu i dalej jedzie z treścią; przy skoku do celu niżej jest przyklejony */
      if (now() < lockUntil) { setFlow(d <= 1); ref = y; return; }
      if (d <= 1) {
        if (up) instant(function () { setUp(false); });
        setFlow(true);
        ref = y;
        return;
      }
      if (d < h) {
        /* strefa miejsca paska: przewija się z treścią; schowany wyłania się spod nagłówka razem z treścią;
           przyklejony zostaje przyklejony */
        if (up) instant(function () { setUp(false); setFlow(true); });
        ref = y;
        return;
      }
      if (flow) {
        instant(function () { setFlow(false); setUp(true); });
        ref = y;
        return;
      }
      if (y > ref + MOVE_PX) { setUp(true); ref = y; }
      else if (y < ref - MOVE_PX) {
        if (up && d < h + Math.round(window.innerHeight / 2)) { ref = y; return; }
        setUp(false);
        ref = y;
      }
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(onFrame);
    }, { passive: true });

    onFrame();
    window.svPdpTabs = true;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
